<template>
	<b-col cols="12" :class="type" class="container mb-4" v-if="info.show">
		<div v-if="closeButton" class="closeIcon" @click="closeClick">
			<b-icon icon="x-circle" />
		</div>
		<div class="body">
			<div class="title">{{ info.title }}</div>
			<div class="info">{{ info.message }}</div>
		</div>
	</b-col>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: "success"
		},
		info: {
			type: Object,
			default: () => {
				return { show: false };
			}
		},
		closeButton: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		closeClick: function () {
			this.info.show = false;
		}
	}
};
</script>

<style scoped>
.success {
	background-color: #ededed;
	border: solid 1px #d6d6d6;
	color: #1c1637;
}

.error {
	background-color: #e76363;
	color: white;
}

.closeIcon {
	float: right;
	margin-top: 10px;
	font-size: 16px;
	cursor: pointer;
}

.container {
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;
}

.body {
	margin: 0px;
}

.title {
	font-size: 14px;
	font-weight: 600;
	color: #1c1637;
	line-height: 19px;

	flex: none;
	order: 0;
	flex-grow: 0;
	margin-bottom: 8px;
}

.info {
	font-size: 12px;
	font-weight: 400;
	color: #1c1637;
	line-height: 16px;

	flex: none;
	order: 1;
	flex-grow: 0;
}
</style>
